module.exports = __webpack_public_path__ + "static/media/gcdef_10007.6c46ea95.ico";